export default __webpack_public_path__ + "static/media/sort-new.de81ce97.svg";